import { render, staticRenderFns } from "./SetLanguage.vue?vue&type=template&id=52884e7b&scoped=true"
import script from "./SetLanguage.vue?vue&type=script&lang=js"
export * from "./SetLanguage.vue?vue&type=script&lang=js"
import style0 from "./SetLanguage.vue?vue&type=style&index=0&id=52884e7b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52884e7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52884e7b')) {
      api.createRecord('52884e7b', component.options)
    } else {
      api.reload('52884e7b', component.options)
    }
    module.hot.accept("./SetLanguage.vue?vue&type=template&id=52884e7b&scoped=true", function () {
      api.rerender('52884e7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/SetLanguage.vue"
export default component.exports